import {Group} from '../../../graphql/groups.datatypes';
import React from 'react';
import GroupOverviewCard from './GroupOverviewCard/GroupOverviewCard';
import HotelsOverviewCard from './HotelsOverviewCard/HotelsOverviewCard';
import OptionsOverviewCard from './OptionsOverviewCard/OptionsOverviewCard';

export const GroupOverview = (props: { group: Group, showPrices: boolean, isAdmin: boolean }) => {
    const {group, showPrices, isAdmin} = props;

    return (
        <React.Fragment>
            <GroupOverviewCard group={group} showPrices={showPrices} isAdmin={isAdmin}/>
            <HotelsOverviewCard group={group} isAdmin={isAdmin}/>
            <OptionsOverviewCard group={group} isAdmin={isAdmin}/>
        </React.Fragment>
    );
};

export default GroupOverview;
